import { QUESTION_MULTIPLE } from '../../constants';
import { escapeHTML } from '../../utils';

class ShortSurveys {
  constructor(options) {
    this.questionsShort = options;
    this.getText = Pollfish.ui.getText;
  }

  renderAnswers = (question) => {
    let answers = '';
    let answerHtml = '';

    question.answers.map((answer) => {
      switch (question.style) {
        case QUESTION_MULTIPLE:
          answerHtml = `
            <div id="a-${answer.id}" class="answerMultipleShort">
              ${escapeHTML(answer.body)}
            </div>
          `;
          break;
        default:
          answerHtml = `
            <div id="a-${answer.id}" class="answerShort listShort">
              ${escapeHTML(answer.body)}
            </div>`;
      }

      answers += answerHtml;
      return true;
    });

    return answers;
  };

  renderImg = (question) => {
    let img = '';
    const questionImageToShow =
      question.optimized_image_url || question.image_url;
    const hasImageToShow = Boolean(questionImageToShow);

    if (hasImageToShow) {
      img = `<img src="${questionImageToShow}" width="100%" />`;
    }

    return `<div class="questionImageShort">${img}</div>`;
  };

  renderQuestionStyle(question) {
    let templ = '';
    let hint = '';
    let answerMultipleOkShort = '';
    const { getText } = this;

    if (question.style === QUESTION_MULTIPLE) {
      hint = `<div id="hintForQuestionTypeShort">${getText(
        'choose_multiple',
      )}</div>`;
      answerMultipleOkShort = `
        <div class="answerMultipleOkShort">
          ${getText('ok_btn')}
        </div>
      `;
    }

    templ = `
      <div id="q-${question.id}" class="questionShort">
        <div class="questionNumberShort">
          <div class="questionNumberTextShort">
            Q${question.count}
          </div>
        </div>
        <div class="questionPromptShort">
          ${question.prompt}
        </div>
        ${hint}
        ${this.renderImg(question)}
        <div class="allAnsShort">
          ${this.renderAnswers(question)}
          <div class="clearer"></div>
        </div>
        ${answerMultipleOkShort}
      </div>
    `;

    return templ;
  }

  renderQuestion() {
    const questions = this.questionsShort.map((q, key) => {
      const question = q;
      if (key >= Pollfish.helper.shortHead) {
        question.count = key + 1;
        return this.renderQuestionStyle(question);
      }
      return '';
    });

    return questions.join('');
  }

  render() {
    let templ = '';
    const { getText } = this;

    templ = `
      <div id="gdpr"></div>
      <div id="containerShort">
      <div id="checkResultsTeaser">
        Check what others have responded by sharing your answer!
      </div>
      ${this.renderQuestion()}
      <div id="thankYouContainerOuterShort"></div>
      <div id="noParticipateContainer">
        <div id="noParticipate">
          <div id="noParticipateText">
            I do not want to participate
          </div>

          <div id="noParticipateArrow">
            ${Pollfish.helper.isIOS() ? '' : '&#10095;'}
          </div>

          <div class="clearer"></div>
        </div>
      </div>
      <div class="footer">
        <p class="text-sm text-grey footer__terms">
          <a href="#" class="js-terms link-theme-hover">${getText(
            'notify_terms',
          )}</a>
        </p>
      </div>
      </div>
      `;

    return templ;
  }
}

export default ShortSurveys;
